import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    optIn: string,
    step: {
        success: {
            redirect: string,
        }
    }
};

export const messagesZHTW: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    schoolName: '學校',
    infoShared1: ' ',
    informationTransferredToUS: ' ',
    infoShared2: '在此處輸入之資訊將用於驗證目的，並與{companyName}共享。',
    optIn: `點擊送出即表示我同意按照 <a target="_blank" class="sid-link" href="https://www.sheerid.com/privacy-policy/">SheerID</a> 和 <a target="_blank" class="sid-link" href="https://www.lenovo.com/privacy/">Lenovo隱私政</a>. 策中所述,驗證我的資格並處理我的信息。同時也了解我的信息會與Lenovo共享。另,您的信息將會根據SheerID的隱私政策和Lenovo的隱私聲明進行處理`,
    country: '國家/地區',
    countries: {
        HK: '中国香港特别行政区',
        TW: '中国台湾',
    },
    step: {
        personalInfo: {

        },
        success: {
            subtitle: '請點擊下面的按鈕繼續購物。您的折扣將直接應用於您的購物車。',
            redirectButtonText: '繼續聯想',
            redirect: '繼續聯想',
            emailNotification: '我們已通過電子郵件將此鏈接發送給您，以便您以後可以繼續購物。查找來自verify@sheerid.com的電子郵件。'
        },
        emailLoop: {
            title:'確認您的電子信箱',
            subtitleWithEmail:'已寄出郵件至 {email}。請使用郵件中的個人連結完成驗證。',
            subtitleWithoutEmail:'已寄出郵件至您的電子信箱。請使用郵件中的個人連結完成驗證。',
            subtitle2:'請參閱我們寄出的電子郵件（verify@sheerid.com）以獲取詳細資訊。',
            successResend:'電子郵件已重新發送。',
            resendButton:'重新發送',
            errors:{
                resend:'發送郵件時出錯',
            },
            skipEmail:'無法找回此封郵件?點擊',
            skipEmailCTA:'這裡',
            skipEmail2:'繼續。'
        }
    },
};
